export default __webpack_public_path__ + "static/media/948.86f3ca35.jpg";